import { DialogType } from '../../@types';
import { WalletType } from '../../@types/api';
import { SPORTSBOOK_WALLET_TYPE } from '../../constants';
import { WALLET_TYPE } from '../../constants/enums';
import useFilterForm from '../../hooks/useFilterForm';
import { AdditionalQueryParams } from '../../hooks/usePagination';
import FilterDialogLayout from '../layouts/FilterDialogLayout';
import FormSelect from '../molecules/FormSelect';

const defaultValues = {
  walletType: WALLET_TYPE.MAIN,
};

type FilterDailyReportsData = {
  walletType?: WalletType;
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterDailyReports = ({ changeQuery, closeModal }: Props) => {
  const { control, handleSubmit, handleResetFilter } = useFilterForm<FilterDailyReportsData>({
    defaultData: defaultValues,
    changeQuery,
  });

  return (
    <FilterDialogLayout
      label='reports'
      onSave={handleSubmit}
      onClose={() => closeModal?.()}
      onReset={handleResetFilter}
    >
      <FormSelect name='walletType' control={control} label='Bets' options={SPORTSBOOK_WALLET_TYPE} />
    </FilterDialogLayout>
  );
};

export default FilterDailyReports;
